
<mat-form-field class="demo-full-width" [formGroup]="group">
<input matInput [formControlName]="field.name" [ngxMatDatetimePicker]="picker" [placeholder]="field.label" [type]="field.inputType">
<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
<ngx-mat-datetime-picker #picker></ngx-mat-datetime-picker>
<ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
<mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
</ng-container>
</mat-form-field>
